module.exports = __webpack_public_path__ + "img/FNS.8ede66ee.jpg";